/* ==========================================================================
   SUNMING LIGHTING — THEME JAVASCRIPT
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initScrollAnimations();
  initDragScroll();
  initMobileNav();
  initNewsletterForm();
  updateCartCount();
});

/* --------------------------------------------------------------------------
   HEADER — transparent on hero, solid on scroll
   -------------------------------------------------------------------------- */
function initHeader() {
  const hdr = document.getElementById('hdr');
  if (!hdr) return;

  const isHomepage = document.body.dataset.template === 'index';

  if (isHomepage) {
    // Homepage: transparent over the dark hero, goes solid on scroll
    window.addEventListener('scroll', () => {
      hdr.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  } else {
    // All other pages: always solid — no transparent state
    hdr.classList.add('scrolled');
  }
}

/* --------------------------------------------------------------------------
   SCROLL ANIMATIONS — fade up on enter viewport
   -------------------------------------------------------------------------- */
function initScrollAnimations() {
  const elements = document.querySelectorAll('.fade');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  elements.forEach(el => observer.observe(el));
}

/* --------------------------------------------------------------------------
   DRAG SCROLL — horizontal scroll strips
   -------------------------------------------------------------------------- */
function initDragScroll() {
  document.querySelectorAll('.feat-scroll, .lookbook-scroll').forEach(el => {
    let down = false, startX, left;

    el.addEventListener('mousedown', e => {
      down = true;
      startX = e.pageX - el.offsetLeft;
      left = el.scrollLeft;
      el.style.cursor = 'grabbing';
    });
    el.addEventListener('mouseleave', () => { down = false; el.style.cursor = 'grab'; });
    el.addEventListener('mouseup', () => { down = false; el.style.cursor = 'grab'; });
    el.addEventListener('mousemove', e => {
      if (!down) return;
      e.preventDefault();
      el.scrollLeft = left - (e.pageX - el.offsetLeft - startX) * 1.6;
    });

    // Touch support
    let touchStartX, touchLeft;
    el.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].pageX;
      touchLeft = el.scrollLeft;
    }, { passive: true });
    el.addEventListener('touchmove', e => {
      const x = e.touches[0].pageX;
      el.scrollLeft = touchLeft + (touchStartX - x) * 1.2;
    }, { passive: true });
  });
}

/* --------------------------------------------------------------------------
   MOBILE NAV
   -------------------------------------------------------------------------- */
function initMobileNav() {
  const toggle = document.querySelector('.hdr-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const closeBtn = document.querySelector('.mobile-nav-close');
  if (!mobileNav) return;

  if (toggle) {
    toggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      document.body.style.overflow = isOpen ? 'hidden' : '';
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Close on overlay click
  mobileNav.addEventListener('click', e => {
    if (e.target === mobileNav) {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  // Accordion for Collections in mobile nav
  document.querySelectorAll('.mobile-nav-accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const sub = trigger.nextElementSibling;
      if (sub && sub.classList.contains('mobile-nav-sub')) {
        sub.classList.toggle('is-open');
        trigger.classList.toggle('is-open');
      }
    });
  });
}

/* --------------------------------------------------------------------------
   NEWSLETTER FORM
   -------------------------------------------------------------------------- */
function initNewsletterForm() {
  const form = document.querySelector('.nl-form');
  if (!form) return;

  // If the form has a real action (Shopify), let it submit normally
  if (form.getAttribute('onsubmit')) return;

  form.addEventListener('submit', async e => {
    e.preventDefault();
    const input = form.querySelector('input[type="email"]');
    const btn = form.querySelector('button');
    const email = input ? input.value.trim() : '';
    if (!email) return;

    btn.textContent = 'Subscribing...';
    btn.disabled = true;

    try {
      const res = await fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          form_type: 'customer',
          utf8: '✓',
          'contact[email]': email,
          'contact[tags]': 'newsletter',
        }),
      });

      if (res.ok) {
        form.innerHTML = '<p style="font-size:14px;color:var(--accent-lt);letter-spacing:0.06em;text-align:center;">Thank you — you\'re subscribed.</p>';
      } else {
        throw new Error();
      }
    } catch {
      btn.textContent = 'Subscribe';
      btn.disabled = false;
    }
  });
}

/* --------------------------------------------------------------------------
   CART — AJAX add & count update
   -------------------------------------------------------------------------- */
async function addToCart(variantId, quantity = 1) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await updateCartCount();
  } catch (err) {
    console.error(err);
  }
}

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const countEl = document.getElementById('cart-count');
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
  } catch (err) {
    // Silently fail — cart count is non-critical
  }
}

// Quick add buttons (product cards)
document.addEventListener('click', e => {
  const btn = e.target.closest('.product-card-quick-add[data-variant-id]');
  if (!btn) return;
  const variantId = btn.dataset.variantId;
  if (variantId) addToCart(variantId);
});
